export default () => ({
  active: false,
  title: "",
  text: "",
  confirmation: false,
  confirmationFn() {},
  onClose() {},
  actions: [],
});
